import { render, staticRenderFns } from "./UploadWithErrorsBlock.vue?vue&type=template&id=efff2ac8&scoped=true"
import script from "./UploadWithErrorsBlock.vue?vue&type=script&lang=ts"
export * from "./UploadWithErrorsBlock.vue?vue&type=script&lang=ts"
import style0 from "./UploadWithErrorsBlock.vue?vue&type=style&index=0&id=efff2ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efff2ac8",
  null
  
)

export default component.exports